import React from 'react';
import PropTypes from 'prop-types';
import useIntl from '@afosto/utils-react/intl/useIntl';
import { usePackingContext } from '../../PackingProvider';
import { useSnackbar } from 'notistack';
import ParcelsDialog from '../../ParcelsDialog';
import { parcels as parcelsApi } from '@afosto/fulfilment/api/Parcels';
import translations from './translations';

const PackingParcelsDialog = ({ isOpen, onClose, onSelect }) => {
  const intl = useIntl();
  const { enqueueSnackbar } = useSnackbar();
  const { currentParcel, setCurrentParcel, parcels, setParcels, shipment } = usePackingContext();

  const handleCreateParcel = async () => {
    try {
      const response = await parcelsApi.createParcel({
        shipment_id: shipment?.id,
      });
      const { data: newParcel } = response ?? {};

      setParcels(currentParcels => [...currentParcels, newParcel]);
      setCurrentParcel(newParcel);

      if (onSelect && typeof onSelect === 'function') {
        onSelect(newParcel);
      }
    } catch (err) {
      enqueueSnackbar(intl.formatMessage(translations.feedback.parcelNotCreated), {
        variant: 'error',
      });
    }
  };

  const handleSelectParcel = parcel => {
    setCurrentParcel(parcel);

    if (onSelect && typeof onSelect === 'function') {
      onSelect(parcel);
    }
  };

  return (
    <ParcelsDialog
      isOpen={isOpen}
      onClose={onClose}
      onCreate={handleCreateParcel}
      onSelect={handleSelectParcel}
      parcels={parcels}
      selectedParcel={currentParcel}
    />
  );
};

PackingParcelsDialog.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  onSelect: PropTypes.func,
};

PackingParcelsDialog.defaultProps = {
  isOpen: false,
  onClose: undefined,
  onSelect: undefined,
};

export default PackingParcelsDialog;
